module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_36.b2bf042d.png";